import React, { useState } from "react";
import { Col, Container, Row, Accordion } from "react-bootstrap";
import Ecommerce from "../../images/services/cto/Ecommerce.svg";
import RealEstate from "../../images/services/cto/RealEstate.svg";
import Gaming from "../../images/services/cto/Gaming.svg";
import Healthcare from "../../images/services/cto/Healthcare.svg";
import Lifestyle from "../../images/services/cto/lifestyle.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Industries(props) {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const getActiveClass = (index, className) =>
    toggleState === index ? className : "";

  return (
    <div className="seriveces_industries p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7}>
            <div className="example" data-text="We Serve">
              <h2>Industries We Serve</h2>
            </div>
            <p className="strong">
              We assist businesses and startups in utilizing modern technology
              to stay competitive. In order to fulfill the needs of every
              industry, we are able to serve a wide range of sectors by
              providing specialized technology solutions and serverless
              computing services.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="deskstop_version"
          >
            <div className="process_icons">
              <ul>
                <li
                  className={`tabs ${getActiveClass(1, "active-tabs")}`}
                  onClick={() => toggleTab(1)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Healthcare}
                      effect="blur"
                      alt="Healthcare"
                      className="img-fluid"
                    />
                  </div>
                  Healthcare
                </li>
                <li
                  className={`tabs ${getActiveClass(2, "active-tabs")}`}
                  onClick={() => toggleTab(2)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={RealEstate}
                      effect="blur"
                      alt="Real Estate"
                      className="img-fluid"
                    />
                  </div>
                  Real Estate
                </li>

                <li
                  className={`tabs ${getActiveClass(3, "active-tabs")}`}
                  onClick={() => toggleTab(3)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Gaming}
                      effect="blur"
                      alt="Gaming"
                      className="img-fluid"
                    />
                  </div>
                  Gaming
                </li>
                <li
                  className={`tabs ${getActiveClass(4, "active-tabs")}`}
                  onClick={() => toggleTab(4)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Ecommerce}
                      effect="blur"
                      alt="Ecommerce"
                      className="img-fluid"
                    />
                  </div>
                  Ecommerce
                </li>
                <li
                  className={`tabs ${getActiveClass(5, "active-tabs")}`}
                  onClick={() => toggleTab(5)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Lifestyle}
                      effect="blur"
                      alt="Lifestyle"
                      className="img-fluid"
                    />
                  </div>
                  Lifestyle
                </li>
              </ul>

              <div
                className={
                  toggleState === 1 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  Our serverless computing solutions provide a robust framework
                  specifically designed to meet the unique needs of the
                  healthcare sector. With our platform, healthcare service
                  providers can effortlessly develop web applications tailored
                  to offer appointment booking services, streamlining patient
                  scheduling processes.
                </p>
              </div>
              <div
                className={
                  toggleState === 2 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  With our serverless computing services, real estate
                  applications can effortlessly accommodate fluctuations in user
                  traffic, ensuring flawless performance during peak periods of
                  property searches and transactions. We allow you to deploy new
                  features and updates at lightning speed, all without the
                  hassle of server maintenance with our streamlined
                  architecture,
                </p>
              </div>
              <div
                className={
                  toggleState === 3 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  In the gaming industry, our serverless solutions ensure
                  uninterrupted gameplay experiences by dynamically modifying
                  infrastructure in response to user demand. We handle duties
                  like user authentication and real-time statistics flawlessly,
                  so your gaming platform runs smoothly even during peak demand
                  periods.
                </p>
              </div>
              <div
                className={
                  toggleState === 4 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  We provide ecommerce businesses with serverless solutions that
                  enable the development of sophisticated web platforms. We use
                  serverless services to create scalable and robust
                  architectures that are ideal for managing product catalogs,
                  processing orders, and smoothly handling customer
                  interactions.
                </p>
              </div>
              <div
                className={
                  toggleState === 5 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  Experience the benefits of our serverless computing solutions
                  designed specifically for lifestyle applications and services.
                  Whether it's fitness tracking, event organizing, or social
                  networking, our serverless technology helps you meet user
                  demands while reducing the burden of infrastructure
                  administration.
                </p>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mobile_version"
          >
            <div className="tekrevol_mobile_accordion_side">
              <Accordion defaultActiveKey="1">
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Healthcare}
                      effect="blur"
                      alt="Healthcare"
                      className="img-fluid"
                    />
                    Healthcare
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Our serverless computing solutions provide a robust
                      framework specifically designed to meet the unique needs
                      of the healthcare sector. With our platform, healthcare
                      service providers can effortlessly develop web
                      applications tailored to offer appointment booking
                      services, streamlining patient scheduling processes.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={RealEstate}
                      effect="blur"
                      alt="Real Estate"
                      className="img-fluid"
                    />
                    Real Estate
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      With our serverless computing services, real estate
                      applications can effortlessly accommodate fluctuations in
                      user traffic, ensuring flawless performance during peak
                      periods of property searches and transactions. We allow
                      you to deploy new features and updates at lightning speed,
                      all without the hassle of server maintenance with our
                      streamlined architecture,
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Gaming}
                      effect="blur"
                      alt="Gaming"
                      className="img-fluid"
                    />
                    Gaming
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      In the gaming industry, our serverless solutions ensure
                      uninterrupted gameplay experiences by dynamically
                      modifying infrastructure in response to user demand. We
                      handle duties like user authentication and real-time
                      statistics flawlessly, so your gaming platform runs
                      smoothly even during peak demand periods.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Ecommerce}
                      effect="blur"
                      alt="Ecommerce"
                      className="img-fluid"
                    />
                    Ecommerce
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      We provide ecommerce businesses with serverless solutions
                      that enable the development of sophisticated web
                      platforms. We use serverless services to create scalable
                      and robust architectures that are ideal for managing
                      product catalogs, processing orders, and smoothly handling
                      customer interactions.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Lifestyle}
                      effect="blur"
                      alt="Lifestyle"
                      className="img-fluid"
                    />
                    Lifestyle
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Experience the benefits of our serverless computing
                      solutions designed specifically for lifestyle applications
                      and services. Whether it's fitness tracking, event
                      organizing, or social networking, our serverless
                      technology helps you meet user demands while reducing the
                      burden of infrastructure administration.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Industries;
